import { render, staticRenderFns } from "./AvatarCard.vue?vue&type=template&id=915e22ec&scoped=true&lang=pug&"
import script from "./AvatarCard.vue?vue&type=script&lang=js&"
export * from "./AvatarCard.vue?vue&type=script&lang=js&"
import style0 from "./AvatarCard.vue?vue&type=style&index=0&id=915e22ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "915e22ec",
  null
  
)

export default component.exports